import { Form, FormSpy } from 'react-final-form';
import { Button, Paper, Typography } from '@mui/material';
import OrderProperty from 'components/containers/OrdersContainer/OrderView/components/OrderProperty';
import OrderPropertiesWrapper from 'components/containers/OrdersContainer/OrderView/components/OrderProperty/OrderPropertiesWrapper';
import OrderPropertyInput from 'components/containers/OrdersContainer/OrderView/components/OrderPropertyInput';

const LocationSection = ({ account, updateAccount, canEdit }) => {
  const inputBase = {
    disabled: false,
  };

  const initialValues = {
    country: account.country || '',
  };

  const onSubmit = (values, form) => {
    updateAccount(values);
    form.reset(values);
  };

  const onResetClick = (form) => {
    form.reset();
  };

  return (
    <Paper className="p20">
      <Typography variant="h2" gutterBottom>
        Location
      </Typography>
      <Form
        initialValues={initialValues}
        onSubmit={onSubmit}
        render={({ handleSubmit, values, form }) => (
          <form onSubmit={handleSubmit} noValidate>
            <OrderPropertiesWrapper>
              <OrderProperty
                label="City lat long"
                value={account.city_lat_long}
              />
              <OrderProperty label="City" value={account.city} />
              <OrderProperty label="Region" value={account.region} />
              <OrderPropertyInput
                label="Country"
                input={{
                  ...inputBase,
                  name: 'country',
                  disabled: !canEdit,
                }}
              />
              <OrderProperty label="Language" value={account.language} />
              <OrderProperty
                label="Browser language"
                value={account.browser_language}
              />
            </OrderPropertiesWrapper>
            {canEdit && (
              <FormSpy subscription={{ pristine: true }}>
                {(props) => (
                  <div className="mt-20">
                    <Button
                      onClick={() => onResetClick(form)}
                      variant="text"
                      disabled={props.pristine}
                    >
                      Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      onClick={handleSubmit}
                      className="ml-10"
                      disabled={props.pristine}
                    >
                      Update
                    </Button>
                  </div>
                )}
              </FormSpy>
            )}
          </form>
        )}
      />
    </Paper>
  );
};

export default LocationSection;
